import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import classes from "../../style/Style.module.css";
import "../../style/Purchase.scss"
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { ROUTE_DXTER_SCANNING, ROUTE_MOBILE_VERIFICATION } from "../../Routes";
import { useLocation, useNavigate } from "react-router-dom";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import LogoutModal from "../../Components/LogoutModal";
import { WhatsApp } from "@mui/icons-material";
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';
import { isMobile, isAndroid, isIOS, isWindows, isMacOs } from "react-device-detect";

const CustomerSupportScreen = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const { reason } = location.state || {};
  const [showModal, setShowModal] = useState(false);

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const HandleSubmit = () => {
    Navigate(ROUTE_DXTER_SCANNING);
  };


  const handleWhatsAppClick = () => {
    const phoneNumber = '+91 8951783311';
    const message = "Hey! I need some help troubleshooting. Can you assist me ?";
    const encodedMessage = encodeURIComponent(message);

    if (isMobile && isIOS) {
      window.open(`whatsapp://send?phone=${phoneNumber}&text=${encodedMessage}`, '_blank');
    } else if (isMobile) {
      window.open(`whatsapp://send?phone=${phoneNumber}&text=${encodedMessage}`, '_blank');
    } else {
      const url = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

      if ((isWindows && window.navigator.userAgent.toLowerCase().includes("whatsapp")) ||
        (isMacOs && window.navigator.userAgent.toLowerCase().includes("whatsapp"))) {
        window.location.href = `whatsapp://send?phone=${phoneNumber}&text=${encodedMessage}`;
      } else {
        window.open(url, '_blank');
      }
    }
  };


  return (
    <div className="DexterSupport_Main_Container">
      <div className="Kyc_Messages_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="NewDexter_Logo">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="Support_Small__Screen_Container">
        <p className="CustomerSupportScreen_Heading_text">
          Contact Dexterr <br />{" "}
          <span className="CustomerSupportScreen_SubHeading_text">
            Support{" "}
          </span>
          Team
        </p>
        <p className="Input_Heading_text">{reason} </p>
        <button className="Submit_button" onClick={HandleSubmit}>
          Go to my Portfolio{" "}
        </button>
        <div className="Dexterr_Footer_Boxes">
          <div className="Dexterr_Footer_Small_Boxes" onClick={handleWhatsAppClick}>
            <WhatsApp style={{ cursor: "pointer" }} />
            <span>Connect through WhatsApp</span>
          </div>
          <div className="Dexterr_Footer_Small_Boxes">
            <MailIcon style={{ cursor: "pointer" }} />
            <span>operations@ambrela.money</span>
          </div>
          <div className="Dexterr_Footer_Small_Boxes">
            <PhoneIcon style={{ cursor: "pointer" }} />
            <span>Contact : +91 895178331</span>
          </div>
        </div>
      </div>
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
    </div>
  );
};

export default CustomerSupportScreen;
